import { CoinThreshold } from '@/types';

import { useReward } from '@/contexts/reward-context';
import { ThresholdDot } from '../threshold-dot';
import { ProgressTip } from '../progress-tip';

export const ThresholdDots = ({ 
	thresholds,
	achievedThreshold
}: {
	thresholds: Array<CoinThreshold>;
	achievedThreshold?: CoinThreshold;
}) => {
	const { currencyName } = useReward();
	const achievedThresholdId = achievedThreshold?.ThresholdId ?? 0;
	const nextThreshold = thresholds.find(threshold => 
		threshold.ThresholdId === achievedThresholdId + 1
	);

	return (
		<>
			<ThresholdDot isChecked />

			{thresholds.map(threshold => {
				const isNextThreshold = threshold.ThresholdId === achievedThresholdId + 1;

				return (
					<ThresholdDot 
						key={threshold.ThresholdId}
						isChecked={threshold.ThresholdId <= achievedThresholdId}
					>
						{isNextThreshold && nextThreshold ? (
							<ProgressTip 
								currencyName={currencyName}
								threshold={nextThreshold} 
							/>
						) : null}
					</ThresholdDot>
				);
			})}
		</>
	);
};